"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.attachmentFileSchema = void 0;
const yup = __importStar(require("yup"));
const utilities_1 = require("../../utilities");
const enums_1 = require("../../enums");
exports.attachmentFileSchema = yup.object().shape({
    id: yup.string().uuid().required(),
    name: yup
        .string()
        .required()
        .max(255)
        .matches(/^[^\\/:*?"<>|]+$/, 'Filename contains invalid characters'),
    size: yup
        .number()
        .required()
        .positive()
        .max(20 * 1024 * 1024, 'File size must be less than 20MB'),
    type: yup.string().test({
        name: enums_1.AttachmentFileValidationErrorType.ValidFileType,
        test: (value, context) => {
            const { allowedTypeList = Object.values(enums_1.AttachmentFileType) } = context.parent;
            if (!value) {
                return false;
            }
            return (0, utilities_1.validateAttachmentFileType)(value, allowedTypeList);
        },
        message: 'Invalid file type',
    }),
    createdAt: yup.number().required().positive(),
    metadata: yup.object().nullable().notRequired(),
    allowedTypeList: yup
        .array()
        .of(yup.string().oneOf(Object.values(enums_1.AttachmentFileType)))
        .nullable()
        .notRequired(),
});
